import React from 'react';
import { Link } from 'react-router-dom';
import "./index.css";

const CardHome = ({ title, icon, links = [] }) => {

    return (
        <div className="card-home">

            <div className="card-home-header">
                <div className="card-home-icon">
                    <i className={`fa ${icon}`} />
                </div>

                <h5>{title}</h5>
            </div>

            <div className="card-home-links">

                {links.map((link, index) => {

                    const isExternal =
                        typeof link.to === "string" &&
                        (
                            link.to.startsWith("http://") ||
                            link.to.startsWith("https://")
                        );

                    if (isExternal) {
                        return (
                            <a
                                key={index}
                                href={link.to}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`card-home-link ${link.className || ""}`}
                            >
                                <div className="link-icon">
                                    {link.icon && (
                                        <i className={`fa ${link.icon}`} />
                                    )}
                                </div>

                                <span>{link.text}</span>

                                <i className="fa fa-chevron-right arrow" />
                            </a>
                        );
                    }

                    return (
                        <Link
                            key={index}
                            to={link.to}
                            className={`card-home-link ${link.className || ""}`}
                        >
                            <div className="link-icon">
                                {link.icon && (
                                    <i className={`fa ${link.icon}`} />
                                )}
                            </div>

                            <span>{link.text}</span>

                            <i className="fa fa-chevron-right arrow" />
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default CardHome;